import { createFcmExperimentsContext } from 'src/app/shared/contexts/experiment';
import type { LoadedStateData } from 'src/app/shared/utils/async';

export const {
	FcmExperimentsContext: StarterDashboardV2PageFcmExperimentsContext,
	FcmExperimentsProvider: StarterDashboardV2PageFcmExperimentsContextProvider,
	useFcmExperiments: useStarterDashboardV2PageFcmExperiments,
	useAsyncFcmExperiments: useAsyncStarterDashboardV2PageFcmExperiments,
	prefetchFcmExperiments: prefetchStarterDashboardV2PageFcmExperiments,
} = createFcmExperimentsContext({
	name: 'StarterDashboardV2PageFcmExperimentsContext',
	dataProperty: 'pageFcmExperiments',
	configs: {
		// DO NOT ADD ANYTHING HERE - USE GQL INSTEAD
	},
	prefetch: true,
});

export type StarterDashboardV2PageFcmExperimentsState = ReturnType<typeof useAsyncStarterDashboardV2PageFcmExperiments>;
export type StarterDashboardV2PageFcmExperiments = LoadedStateData<StarterDashboardV2PageFcmExperimentsState>;
